import logoImageDesktop from '../assets/biketribe-logo-desktop.png';
import logoImageMobile from '../assets/biketribe-logo-mobile.png';
import brandImage from '../assets/biketribe-brandImage-1500.jpg';
import facebookImage from '../assets/biketribe-facebook-sharing-1200x630.jpg';
import twitterImage from '../assets/biketribe-twitter-sharing-600x314.jpg';

/////////////////////////////////////////////////////////
// This file contains configs that affect branding     //
// NOTE: these are just some of the relevant configs   //
// Most of the work happens in marketplaceDefaults.css //
// and in components.                                  //
/////////////////////////////////////////////////////////

// Note: These come from the branding asset nowadays by default.
//       To use this built-in configuration, you need to remove the overwrite from configHelper.js (mergeBranding func)

// Marketplace color.
// This is saved as CSS Property: --marketplaceColor in src/app.js
// Also --marketplaceColorDark and --marketplaceColorLight are generated from this one
// by adding +/- 10% to lightness.
export const marketplaceColor = '#7c3aed';

// Logo is used in Topbar on mobile and desktop, where height is the limiting factor.
// Therefore, we strongly suggest that your image file for desktop logo is in landscape!
//
// If you need to fine-tune the logo, the component is defined in src/components/Logo/Logo.js
// By default logo gets 24 pixels vertical space, but it could be wider (e.g. 180px)
// The default images are meant for retina displays and are therefore twice as big in actual dimensions
export const logoImageDesktopURL = logoImageDesktop;
export const logoImageMobileURL = logoImageMobile;

// The _logoSettings_ settings for the logo. Due to constraints in current Topbar, we only support 4 height variants
// at this point. There could be more height variants in the future and potentially other logo formats than 'image'.
// Note: logo image is always scaled and the limiting factor is height. However, there's also maximum width,
//       which is 450px in the Topbar. If the logo is wider than that, browser will scale it down.
// Logo
// Default:
// logoSettings: { format: 'image', height: 24 }
//
// Generic settings for 'image' logo format.
// Height must be one of the following: 24, 36, 48, 60, 72
// Width will be calculated from the height and image aspect ratio.
//
// Default:
// logoImageMobile: { src: defaultLogoMobile, fitViewport: true },
// logoImageDesktop: { src: defaultLogoDesktop, fitViewport: false },
export const logoSettings = { height: 72, format: 'image' };

// Asset images for 'image' logo format
// If you want to use the default images, you can just comment out
// the following lines.
//
// NOTE: If you have S3 bucket, you should use images from there.
// (Remember to configure 'cdnAssetsPath' correctly in config.js)
//
// export const logoImageMobile = { src: mobileLogo, fitViewport: true };
// export const logoImageDesktop = { src: desktopLogo, fitViewport: false };

// Text based logo
// Default:
// logoSettings: { format: 'text', text: marketplaceName }
//
// If you want to use text-based logo, you can use the following settings:
// export const logoSettings = { format: 'text', text: 'MyMarketplace' };
// And then you can style it with CSS variables.
// See: src/components/Logo/Logo.module.css
//
// End of Logo
//
// -- ManagedAvailability --
// ...existing code...
